/**
 * The global state selectors
 */

import { createSelector } from "reselect";
import { initialState } from "./reducer";

const selectGlobal = (state) => state.app || initialState;

const selectUser = (state) => state.app.currentUser;

const selectUserFullname = (state) => state.app.currentUser.fullName;

const selectUserEmail = (state) => state.app.currentUser.email;

const selectUserId = (state) => state.app.currentUser.userId;

const selectUserImage = (state) => state.app.currentUser.imagePreviewPath;

const selectDatasetId = (state) => state.app.sourceInfo.datasetId;

const selectProjectId = (state) => state.app.sourceInfo.projectId;

const selectSourceId = (state) => state.app.sourceInfo.sourceId;

const selectCustomerReview = (state) => state.app.sourceInfo.customerReview;

const selectIsChangingDropdown = (state) => state.app.isChangingDropdown;

const selectListUser = (state) => state.app.listUser;
const selectLabelerId = (state) => state.app.labelerId;

const selectDialogOpen = (state) => state.app.dialogOpen;

export const selectPermissionComponent = (module) =>
  createSelector(selectGlobal, (global) => global.moduleCode.includes(module));

const selectCurrentDropdownStatus = (state) => state.app.currDropDownStatus;

export const selectCurrentUser = (state) => state.app.currentUser;

export const selectLocale = (state) => state.app.locale;

export const selectIsOpenStatus = (state) => state.app.isOpenDialogChangeStatus;

export const selectCarCompanies = (state) => state.app.carCompanies;

export const selectTargetLabels = (state) => state.app.targetLabels;

export const selectIsLoadingAutoLabel = (state) => state.app.isLoadingAutoLabel;
export const selectReporterTab = (state) => state.app.reporterTab || "labeling";

export const selectAuditLogs = (state) => state.app.auditLogs;
export const selectAuditUsers = (state) => state.app.auditUsers;
export const selectAuditLoading = (state) => state.app.auditLogsLoading;

export const selectCanPermissionEditAndLabelingTab = (status) => (state) =>
  !!state?.permission?.permissions?.[status]?.edit &&
  state.app.reporterTab === "labeling";

export {
  selectUser,
  selectIsChangingDropdown,
  selectCurrentDropdownStatus,
  selectGlobal,
  selectUserFullname,
  selectUserImage,
  selectUserId,
  selectDatasetId,
  selectProjectId,
  selectCustomerReview,
  selectSourceId,
  selectListUser,
  selectLabelerId,
  selectDialogOpen,
  selectUserEmail,
};
